import Hero from '@/components/Hero';
import ServicesOverview from '@/components/ServicesOverview';
import ContactCTA from '@/components/ContactCTA';
import Seo from '@/components/Seo';

const Index = () => {
  return (
    <>
      <Seo
        title="AI Workforce, Governance & Growth Consulting | Marsh"
        description="AI workforce, AI provenance, gamified professional development, and 24/7 AI receptionist services that move your bottom line and retain employees."
        path="/"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'ProfessionalService',
          name: 'Marsh Business Solutions',
          url: 'https://marsh.business/',
          telephone: '+1-313-444-9824',
          email: 'stephen@marsh.business',
          areaServed: 'US',
        }}
      />
      <Hero />
      <ServicesOverview />
      <ContactCTA />
    </>
  );
};

export default Index;

